export default function description() {
    return (
        <div className="card__description-basic">
            <div className="card__description">
                <div className="card__description-title">Загальна характеристика</div>
                <p className="card__description-text">
                    АЕРОН — це гібрид, створений для стабільної роботи в різних умовах вирощування. Його ключова ідея — адаптивність + витривалість, що дозволяє отримувати прогнозований результат навіть у складних кліматичних умовах.
                </p>
                <p className="card__description-text">
                    Гібрид добре показує себе як на родючих, так і на бідніших ґрунтах.
                </p>
                <ol className="card__description-list">
                    <p className="card__description-title">
                        Продуктивність і якість
                    </p>
                    <li className="card__description-numbering">Потенціал урожайності: до 5,0 т/га</li>
                    <li className="card__description-numbering">Олійність: 50–54%</li>
                    <li className="card__description-numbering">Стійкість до вовчка — A–G</li>
                    <p className="card__description-text">
                        Формує стабільний урожай із хорошими показниками якості насіння.
                    </p>
                </ol>
                <div className="card__description-title">Морфологія та розвиток</div>
                <ol className="card__description-list">
                    <li className="card__description-numbering">Вегетаційний період: 104–106 днів</li>
                    <li className="card__description-numbering">Висота рослин: 160–180 см</li>
                    <p className="card__description-text">
                        Гібрид має добре збалансовану архітектуру рослини, що сприяє рівномірному дозріванню.
                    </p>
                </ol>
                <div className="card__description-title">Адаптивність</div>
                <ol className="card__description-list">
                    <p className="card__description-text">
                        Рекомендований для вирощування у:
                    </p>
                    <li className="card__description-numbering">Степу</li>
                    <li className="card__description-numbering">Лісостепу</li>
                    <p className="card__description-text">
                        Особливо ефективний у зонах із нестабільним зволоженням.
                    </p>
                </ol>
                <div className="card__description-title">Поведінка в полі</div>
                <ol className="card__description-list">
                    <li className="card__description-numbering">Енергія стартового росту — 9/10</li>
                    <li className="card__description-numbering">Посухостійкість — 9/10</li>
                    <li className="card__description-numbering">Стійкість до вилягання — 8/10</li>
                    <p className="card__description-text">
                        Гібрид швидко стартує, рівномірно розвивається і добре тримає густоту.
                    </p>
                </ol>
                <div className="card__description-title">Ключові переваги</div>
                <ol className="card__description-list">
                    <li className="card__description-numbering">Висока посухостійкість і адаптивність</li>
                    <li className="card__description-numbering">Стабільний результат навіть на бідних ґрунтах</li>
                    <li className="card__description-numbering">Пластичність до умов вирощування</li>
                    <li className="card__description-numbering">Потужна коренева система</li>
                </ol>
                <div className="card__description-title">Практичне застосування</div>
                <ol className="card__description-list">
                    <p className="card__description-title">
                        АЕРОН ідеально підходить для:
                    </p>
                    <li className="card__description-numbering">екстенсивного землеробства</li>
                    <li className="card__description-numbering">господарств із різним рівнем технологій</li>
                    <li className="card__description-numbering">полів із нерівномірним забезпеченням вологою</li>
                    <p className="card__description-text">
                        Рекомендується застосування гербіцидів системи Clearfield®.
                    </p>
                </ol>
                <div className="aside__title">Агрохімічні характеристики</div>
                <div className="aside__content">
                    <div className="aside-char--basic">
                        <div className="aside-char__head">Енергiя початкового росту</div>
                        <div className="aside-char__char">
                            <div className="aside-char__items aside-char__items--9">
                                <span></span>
                                <span></span>
                                <span></span>
                                <span></span>
                                <span></span>
                                <span></span>
                                <span></span>
                                <span></span>
                                <span></span>
                            </div>
                            <div className="aside-char__count">9</div>
                        </div>
                    </div>
                    <div className="aside-char--basic">
                        <div className="aside-char__head">Посухостiйкiсть</div>
                        <div className="aside-char__char">
                            <div className="aside-char__items aside-char__items--9">
                                <span></span>
                                <span></span>
                                <span></span>
                                <span></span>
                                <span></span>
                                <span></span>
                                <span></span>
                                <span></span>
                                <span></span>
                            </div>
                            <div className="aside-char__count">9</div>
                        </div>
                    </div>
                    <div className="aside-char--basic">
                        <div className="aside-char__head">Стiйкiсть до вилягання</div>
                        <div className="aside-char__char">
                            <div className="aside-char__items aside-char__items--8">
                                <span></span>
                                <span></span>
                                <span></span>
                                <span></span>
                                <span></span>
                                <span></span>
                                <span></span>
                                <span></span>
                            </div>
                            <div className="aside-char__count">8</div>
                        </div>
                    </div>
                </div>
                <p className="card__description-text">
                    АЕРОН — це гібрид для тих, хто шукає надійність, адаптивність і стабільний результат без ризиків.
                </p>
            </div>
            <div className="card__description-preference">
                <div className="aside__title--new">Головні переваги</div>
                <div className="asede__head">
                    <div className="aside__block">Відмінна посухостійкість та адаптація до різних кліматичних зон України</div>
                    <div className="aside__block">Пластичний до різних умов вирощування – стабільний навіть на бідних ґрунтах</div>
                    <div className="aside__block">Швидкий стартовий ріст та сильна коренева система</div>
                </div>
            </div>
        </div>
    );
}
